import { PMA_DEFAULT_TOOLS } from './pmaLabAccess';
import {
  defaultDurationToken,
  normalizePoSchedule,
  normalizeProgramDuration,
  DURATION_EDITABLE_PROGRAMS,
} from './pmaLifecyclePolicy';

export const PROGRAM_TYPES = ['PO', 'TI', 'WS', 'UP', 'TS', 'CG', 'CO', 'VE', 'SP'];
export const USER_CATEGORIES = ['normal', 'bulk', 'corporate', 've_trainer', 'special', 'cg'];
export const MODES = ['Offline', 'Online'];
export const CENTERS = ['Noida', 'Bangalore', 'Mysuru', 'Chennai', 'Roorkee'];

export const PROGRAM_NAMES = {
  PO: 'Placement Oriented',
  TI: 'Technical Internship',
  WS: 'Workshop',
  UP: 'Upskilling',
  TS: 'TS',
  CG: 'ChipGrad',
  CO: 'Corporate',
  VE: 'VE Trainer',
  SP: 'Special Privileged',
};

export const DEFAULT_PMA_POLICY = {
  programType: 'PO',
  programName: 'Placement Oriented',
  userCategory: 'normal',
  mode: 'Offline',
  center: 'Noida',
  batchNo: '',
  poSchedule: 'regular',
  programDuration: '9m',
  tools: PMA_DEFAULT_TOOLS,
  linuxGroups: [],
  vncFqdn: '',
  puttyFqdn: '',
};

/** Workshop → ws (/ve/ws_home). ChipGrad → cg (/ve/cg_home). Other programs keep the selected groups. */
export function defaultLinuxGroupsForProgram(programType, linuxGroups = []) {
  if (Array.isArray(linuxGroups) && linuxGroups.length) return linuxGroups;
  const program = String(programType || '').toUpperCase();
  if (program === 'WS') return ['ws'];
  if (program === 'CG') return ['cg'];
  return [];
}

export function linuxGroupsForProgramType(programType, linuxGroups = []) {
  const program = String(programType || '').toUpperCase();
  const current = Array.isArray(linuxGroups) ? linuxGroups : [];
  if (program === 'WS') return ['ws', ...current.filter((g) => g !== 'ws' && g !== 'po')];
  if (program === 'CG') return ['cg', ...current.filter((g) => g !== 'cg' && g !== 'po')];
  return current.length ? current : defaultLinuxGroupsForProgram(program);
}

export function linuxHomeForGroup(group) {
  const name = String(group || '').trim() || 'users';
  return `/ve/${name}_home`;
}

export function pmaWorkbookFilename(policy) {
  const batch = String(policy.batchNo || '').replace(/\D/g, '');
  const center =
    policy.mode === 'Online'
      ? ''
      : String(policy.center || '')
          .trim()
          .charAt(0)
          .toLowerCase();
  if (batch) return `USER_ID_b${batch}${center}_batch.xlsx`;
  return 'USER_ID_batch.xlsx';
}

export function validatePmaIdentityPolicy(policy) {
  const errors = [];
  if (!PROGRAM_TYPES.includes(policy.programType)) errors.push('program_type is required');
  if (!String(policy.programName || '').trim()) errors.push('program_name is required');
  if (!MODES.includes(policy.mode)) errors.push('mode must be Offline or Online');
  if (policy.mode === 'Offline' && !policy.center) errors.push('Center is required for Offline');
  if (DURATION_EDITABLE_PROGRAMS.includes(policy.programType) && !normalizeProgramDuration(policy.programDuration)) {
    errors.push('program duration is required (e.g. 15d or 9m)');
  }
  return { valid: errors.length === 0, errors };
}

export function policyToQuery(policy) {
  return {
    programType: policy.programType,
    programName: policy.programName,
    userCategory: policy.userCategory,
    mode: policy.mode,
    center: policy.mode === 'Online' ? '' : policy.center,
    batchNo: policy.batchNo || '',
    poSchedule: normalizePoSchedule(policy.poSchedule),
    programDuration:
      normalizeProgramDuration(policy.programDuration) ||
      defaultDurationToken({
        programType: policy.programType,
        userCategory: policy.userCategory,
        poSchedule: policy.poSchedule,
      }),
    tools: policy.tools || PMA_DEFAULT_TOOLS,
    linuxGroups: defaultLinuxGroupsForProgram(policy.programType, policy.linuxGroups || []).join(','),
    vncFqdn: policy.vncFqdn || '',
    puttyFqdn: policy.puttyFqdn || '',
  };
}
